(() => {
  const init = () => {
    document.querySelectorAll('.rwa-cover img').forEach(img => {
      if (img.dataset.rewelChecked) return;
      img.dataset.rewelChecked = '1';
      const hideBroken = () => { img.closest('.rwa-cover').hidden = true; };
      if (img.complete && !img.naturalWidth) hideBroken();
      img.addEventListener('error', hideBroken, {once:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
